import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../utils/config-service';
import { Observable, Subject } from 'rxjs/Rx';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/empty';
import { UserData } from '../../models/userData';

@Injectable()
export class UserApiService {
    private accountUrl: string;
    private clientId: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.accountUrl = this.configService.getEnv('accountApi');
        this.clientId = this.configService.getEnv('oauthClientId');
    }

    getUserData(): Promise<UserData> {
        return this.http.get(this.accountUrl + 'UserData')
            .toPromise()
            .then((result: any) => {
                let json = result;
                return new UserData(json);
            }).catch((error: any) => {
                throw error;
            });
    }

    setUserData(userData: UserData): Promise<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let json = JSON.stringify(userData);
        return this.http.put(this.accountUrl + 'UserData', json, { headers: headers })
            .toPromise()
            .then((result: any) => {
                return result;
            }).catch((error: any) => {
                throw error;
            });
    }

    login(googleUser: any): Observable<any> {
        let googleToken = googleUser.getAuthResponse();
        const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'no-auth': 'true' });
        const body: any = `grant_type=googleid&client_id=${this.clientId}&googleid=${googleToken.id_token}`;
        return this.http.post(this.accountUrl + 'token', body, {'headers': headers});
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/user/user.api.service.ts